import React, { useCallback, useContext, useState } from "react";
import { Nav, NavItem } from "reactstrap";
import { Building2, Coins, Search } from "lucide-react";
import CommandPalette, { commandShortcutLabel } from "./CommandPalette";
import ProfileDropdown from "./ProfileDropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCrown } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import NotificationDropdown from "./NotificationDropdown";
import { CurrencyContext } from "../../context/Context";
import ModalSelectedMoneyType from "../condominium/components/ModalSelectedMoneyType";
import RewardsCoinsBadge from "../rewards/RewardsCoinsBadge";
import { REWARDS_ENABLED } from "../../helpers/rewardsEnabled";

const TopNavRightSideNavItem = () => {
  const {
    condominium: { selectedCondominium, condominium },
    auth: {
      user: { role, hasMultipleProperties },
    },
    property: { selectedProperty, propertyLabel },
  } = useSelector((state) => state);

  const { currency: curr } = useContext(CurrencyContext);
  const [openMoneyModal, setOpenMoneyModal] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);
  const openCommand = useCallback(() => setCommandOpen(true), []);
  const closeCommand = useCallback(() => setCommandOpen(false), []);

  // HO-HU-37: en la pantalla de "elegir propiedad" (mustSelectProperty en
  // DashboardRoutes.jsx) toda ruta que no sea /dashboard/app rebota de
  // vuelta ahi -- clickear una notificacion de ahi no lleva a ningun lado
  // todavia (su destino tambien rebotaria), así que no tiene sentido
  // mostrar la campana en ese momento.
  const mustSelectProperty =
    role === "property" && hasMultipleProperties && !selectedProperty;

  return (
    <>
      <Nav
        navbar
        className="navbar-nav-icons ml-auto flex-row align-items-center"
      >
        {selectedCondominium && role !== "root" && (
          <>
            <NavItem
              className="hl-topbar-chip hl-topbar-chip--context"
              title={
                role === "property" && hasMultipleProperties && propertyLabel
                  ? `${condominium} · ${propertyLabel}`
                  : condominium
              }
            >
              <Building2 size={16} strokeWidth={1.75} className="hl-topbar-chip__icon" aria-hidden="true" />
              <span className="hl-topbar-chip__label">
                {condominium}
                {/* HO-HU-37: con varias propiedades vinculadas, sin esto no
                    habia forma de saber -mirando el navbar- cual de todas
                    quedo seleccionada (el condominio solo no alcanza
                    cuando 2 propiedades caen en el mismo condominio). */}
                {role === "property" && hasMultipleProperties && propertyLabel && (
                  <span className="hl-topbar-chip__sub"> · {propertyLabel}</span>
                )}
              </span>
            </NavItem>
            <NavItem className="d-flex align-items-center">
              <button
                type="button"
                className="hl-topbar-chip hl-topbar-chip--button"
                onClick={() => setOpenMoneyModal(true)}
                title="Cambiar moneda"
              >
                <Coins size={16} strokeWidth={1.75} className="hl-topbar-chip__icon" aria-hidden="true" />
                <span className="hl-topbar-chip__label">
                  {curr?.currency?.iso ? curr.currency.iso : "Moneda"}
                </span>
              </button>
            </NavItem>
          </>
        )}
        {role === "root" && (
          <NavItem className="hl-topbar-chip flex-shrink-0">
            <FontAwesomeIcon className="hl-topbar-chip__icon text-warning" icon={faCrown} />
            <span className="hl-topbar-chip__label">Root</span>
          </NavItem>
        )}
        <NavItem className="d-flex align-items-center">
          <button
            type="button"
            className="hl-search-trigger"
            onClick={() => setCommandOpen(true)}
            aria-label="Buscar páginas y acciones"
          >
            <Search size={18} strokeWidth={1.75} aria-hidden="true" />
            <span>Buscar páginas, acciones…</span>
            <kbd>{commandShortcutLabel}</kbd>
          </button>
          <button
            type="button"
            className="hl-icon-button d-none d-sm-inline-flex d-lg-none"
            onClick={() => setCommandOpen(true)}
            aria-label="Buscar páginas y acciones"
          >
            <Search size={18} strokeWidth={1.75} aria-hidden="true" />
          </button>
        </NavItem>
        {/* HO-TASK-290: Coins ganados sin ver (solo propietarios). */}
        {REWARDS_ENABLED && role === "property" && !mustSelectProperty && <RewardsCoinsBadge />}
        {!mustSelectProperty && role !== "provider" && <NotificationDropdown />}
        <ProfileDropdown />
      </Nav>

      <CommandPalette
        isOpen={commandOpen}
        onOpen={openCommand}
        onClose={closeCommand}
      />
      <ModalSelectedMoneyType
        open={openMoneyModal}
        toggle={() => setOpenMoneyModal(!openMoneyModal)}
      />
    </>
  );
};

export default TopNavRightSideNavItem;
